<template>
  <ValidationProvider tag="div"
                      class="validated-input"
                      :class="{'no-label': !$props.label}"
                      :mode="validationMode"
                      ref="validationProvider"
                      :rules="$props.rules"
                      :name="$props.validateAs"
                      :vid="$props.vid"
                      v-slot="{ errors }">
    <base-input v-bind="[$props, $attrs]" @focus="handleFocus" @blur="handleBlur" v-model="currentValue" :invalid="!!errors[0]" ref="input">
      <!-- pass down all slots to child input -->
      <template v-for="(index, name) in $slots" v-slot:[name]>
        <slot :name="name"></slot>
      </template>
    </base-input>
    <!-- error message -->
    <transition name="fade">
      <span class="error-msg" :class="{'no-label': !$props.label}" v-if="errors[0]">{{ errors[0] }}</span>
    </transition>
  </ValidationProvider>
</template>

<script>
export default {
  name: 'base-v-input',
  inheritAttrs: false,
  props: {
    value: {
      required: true,
      default: ''
    },
    rules: {
      type: [String, Object],
      default: 'required'
    },
    vid: {
      type: String,
      default: undefined
    },
    validateAs: {
      type: String,
      default: ''
    },
    mode: String,
    submitted: Boolean,
    label: String
  },
  computed: {
    currentValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    validationMode () {
      if (this.$props.submitted) {
        return 'eager'
      } else if (this.$props.mode && !this.$props.submitted) {
        return this.$props.mode
      }
      return 'passive'
    }
  },
  methods: {
    handleFocus (e) {
      this.$emit('focus', e)
    },
    handleBlur (e) {
      this.$emit('blur', e)
    },
    focusIn () {
      this.$refs.input.focusIn()
    },
    focusOut () {
      this.$refs.input.focusOut()
    }
  }
}
</script>

<style scoped lang="scss" src="./base-comp-styles/base-input.scss"></style>
